import script from "./MainFrame.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainFrame.vue?vue&type=script&setup=true&lang=ts"

import "./MainFrame.vue?vue&type=style&index=0&id=1ca396dd&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca396dd"]])

export default __exports__